/* @flow */

export const NODE_TYPE = {
  ELEMENT: ("element": "element"),
  TEXT: ("text": "text"),
  COMPONENT: ("component": "component"),
  FRAGMENT: ("fragment": "fragment"),
};
